export default "__VITE_ASSET__c1d33984__"